<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="repairRegistrationVo.pkid > 0 ? '编辑' : '新建'"
      class="replacementBill-edit"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="repairRegistrationVo"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="产品条码">
            <el-input v-model="repairRegistrationVo.barcode"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="报修人">
            <el-input v-model="repairRegistrationVo.workerName"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="报修时间">
            <el-date-picker
                v-model="repairRegistrationVo.faultTime"
                style="width: 190px"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="物料代码">
            <el-input v-model="repairRegistrationVo.materialNo" placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectRepairMaterial.open()">
                选择
              </el-button>
            </el-input>
            <material-select ref="selectRepairMaterial" @select="selectMaterial"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物料名称">
            <el-input v-model="repairRegistrationVo.materialName"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物料型号">
            <el-input v-model="repairRegistrationVo.specification"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="报修工序">
            <el-input v-model="repairRegistrationVo.processName"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="异常内容">
            <el-input v-model="repairRegistrationVo.exceptionNote"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="批次数量">
            <el-input v-model="repairRegistrationVo.batchQuantity" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="异常项目">
            <el-input v-model="repairRegistrationVo.faultReporting" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="实测故障">
            <el-input v-model="repairRegistrationVo.faultActual" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="原因分析">
            <el-cascader
                v-model="repairRegistrationVo.reasonAnalise"
                :options="options"
                :props="{ checkStrictly: true }"
                clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="维修人员">
            <el-input v-model="repairRegistrationVo.repairName" placeholder="请选择" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectRegionalManager.open()"/>
            </el-input>
            <user-select ref="selectRegionalManager" @select="selectRegionalManager"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="维修时间">
            <el-date-picker
                v-model="repairRegistrationVo.repairTime"
                style="width: 190px"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="维修状态">
            <el-select v-model="repairRegistrationVo.status">
              <el-option label="已签收" :value="1"/>
              <el-option label="已修" :value="2"/>
              <el-option label="疑难杂症" :value="3"/>
              <el-option label="报废" :value="4"/>
              <el-option label="可用" :value="5"/>
              <el-option label="不可用" :value="6"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否老化">
            <el-radio-group v-model="repairRegistrationVo.isBurnIn">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="repairRegistrationVo.note" type="textarea"/>
      </el-form-item>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          明细表
        </div>
        <el-button
            type="primary"
            style="margin-bottom: 10px"
            @click="addDetails">
          添加物料
        </el-button>
        <el-table
            :data="repairRegistrationVo.details"
            border>
          <el-table-column prop="shapeCode" width="160" align="center" label="条形码">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.shapeCode"
                  autosize
                  type="textarea"
                  placeholder="请输入"
                  @keyup.enter.native="getProcess2(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="materialNo" width="160" align="center" label="物料号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.materialNo" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="specifications" width="160" align="center" label="物料型号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specifications" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="materialName" width="160" align="center" label="物料描述">
            <template slot-scope="scope">
              <el-input v-model="scope.row.materialName" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="repairResult" width="160" align="center" label="故障描述">
            <template slot-scope="scope">
              <el-input v-model="scope.row.repairResult" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="afterSpecifications" width="160" align="center" label="更换器件">
            <template slot-scope="scope">
              <el-input v-model="scope.row.afterSpecifications" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="maintenanceRecord" width="160" align="center" label="维修记录">
            <template slot-scope="scope">
              <el-input v-model="scope.row.maintenanceRecord" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="problemType" width="160" align="center" label="问题分类">
            <template slot-scope="scope">
              <el-cascader
                  v-model="scope.row.problemType"
                  :options="options"
                  :props="{ checkStrictly: true }"
                  clearable/>
            </template>
          </el-table-column>
          <el-table-column prop="snowboardSupplier" width="160" align="center" label="单板供应商">
            <template slot-scope="scope">
              <el-input v-model="scope.row.snowboardSupplier" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="positionNo" width="160" align="center" label="器件位号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.positionNo" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="100px">
            <template slot-scope="scope">
              <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          附件
        </div>
        <div
            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            v-if="repairRegistrationVo.attachments"
            ref="payData1"
            :data="repairRegistrationVo.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileName"
                  class="tabInput"
                  style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import UploadFile from "@/components/UploadFile";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import LoginUtil from "@/util/loginUtil";

  export default {
    name: "RepairRegistrationEdit",
    components: {MaterialSelect, UploadFile, UserSelect},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        options: [
          {
            value: "PCBA外协",
            label: "PCBA外协",
            children: [{
                         value: "虚焊",
                         label: "虚焊",
                       },
                       {
                         value: "空焊",
                         label: "空焊",
                       },
                       {
                         value: "少件",
                         label: "少件",
                       },
                       {
                         value: "连焊",
                         label: "连焊",
                       },
                       {
                         value: "撞件",
                         label: "撞件",
                       },
                       {
                         value: "错件",
                         label: "错件",
                       },
                       {
                         value: "异物",
                         label: "异物",
                       },
                       {
                         value: "立件/立碑",
                         label: "立件/立碑",
                       },
                       {
                         value: "偏移",
                         label: "偏移",
                       },{
                         value: "反向",
                         label: "反向",
                       },
                       {
                         value: "铜箔断裂",
                         label: "铜箔断裂",
                       },
                       {
                         value: "坏件",
                         label: "坏件",
                       },
            ],
          },
          {
            value: "材料不良",
            label: "材料不良",
          },
          {
            value: "测试正常",
            label: "测试正常",
          },
          {
            value: "生产作业不良",
            label: "生产作业不良",
            children: [{
                         value: "组装不良",
                         label: "组装不良",
                       },
                       {
                         value: "焊接不良",
                         label: "焊接不良",
                       },
                       {
                         value: "漏写程序",
                         label: "漏写程序",
                       },
            ],
          },
          {
            value: "待分析",
            label: "待分析",
          },
          {
            value: "程序BUG",
            label: "程序BUG",
          },
        ],
        responsibilitySelect: [
          {
            value: "原材料",
            label: "原材料",
            children: [{
                         value: "电子料不良",
                         label: "电子料不良",
                       },
                       {
                         value: "其他料不良",
                         label: "其他料不良",
                       },
                       {
                         value: "PCBA外协",
                         label: "PCBA外协",
                       },
            ],
          },
          {
            value: "客户端",
            label: "客户端",
            children: [{
                         value: "客供料",
                         label: "客供料",
                       },
                       {
                         value: "使用不当",
                         label: "使用不当",
                       },
                       {
                         value: "应用环境(水、油、异物、腐蚀等)",
                         label: "应用环境(水、油、异物、腐蚀等)",
                       },
                       {
                         value: "固件异常",
                         label: "固件异常",
                       },
                       {
                         value: "应用问题(过载、过压、堵转等)",
                         label: "应用问题(过载、过压、堵转等)",
                       },

            ],
          },
          {
            value: "研发设计",
            label: "研发设计",
            children: [{
                         value: "设计缺陷",
                         label: "电子料不良",
                       },
                       {
                         value: "器件选型",
                         label: "器件选型",
                       },
            ],
          },
          {
            value: "生产作用",
            label: "生产作用",
            children: [{
                         value: "焊接问题",
                         label: "焊接问题",
                       },
                       {
                         value: "装配问题",
                         label: "装配问题",
                       },
                       {
                         value: "工装测试",
                         label: "工装测试",
                       },
            ],
          },
          {
            value: "检查正常",
            label: "检查正常",
            children: [{
              value: "检查正常",
              label: "检查正常",
            },
            ],
          },
          {
            value: "原因不明",
            label: "原因不明",
            children: [{
              value: "疑难杂症",
              label: "疑难杂症",
            },
            ],
          },


        ],
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        repairRegistrationVo: {
          pkid: "",
          billNo: "",
          type: 20,
          receiveTime: "",
          batchQuantity: "",
          productBarCode: "",
          accomplishCodeDesc: "",
          processInCode: "",
          accomplishCode: "",
          nodeCode: "",
          creatTime: "",
          receiveName: "",
          barcode: "",
          materialId: "",
          materialNo: "",
          materialName: "",
          customerName: "",
          attachments: [],
          isWarranty: true,
          isCharge: true,
          hardwareVersion: "",
          softwareVersion: "",
          historicalAlarms: "",
          faultReporting: "",
          faultActual: "",
          exceptionNote: "",
          faultTime: "",
          maintenanceRecord: "",
          repairId: "",
          repairName: LoginUtil.getName(),
          workerName: "",
          replacementParts: "",
          note: "",
          status: "",
          repairTime: "",
          chargedAmount: "",
          workerNo: "",
          faultType: "",
          isBurnIn: true,
          details: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "blur"},
          orderReturnReasonName: {required: true, message: "退货原因不能为空", trigger: "blur"},
          typeName: {required: true, message: "退货类型不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.repairRegistrationVo.pkid = row.pkid;
          if (this.repairRegistrationVo.pkid > 0) {
            this.getData();
          }
        }
      },
      getData() {
        this.$http
          .get("basic", `repairRegistrations/${this.repairRegistrationVo.pkid}`)
          .then(resp => {
            this.repairRegistrationVo = resp.data;
            if (!this.repairRegistrationVo.repairName) {
              this.repairRegistrationVo.repairName = LoginUtil.getName();
              this.repairRegistrationVo.repairId = LoginUtil.getUserId();
            }
            if (this.repairRegistrationVo.reasonAnalise) {
              this.repairRegistrationVo.reasonAnalise = this.repairRegistrationVo.reasonAnalise.split("/");
            }
            if (this.repairRegistrationVo.details.length>0) {
              this.repairRegistrationVo.details.forEach((item) => {
                if (item.problemType) {
                  console.log(item.problemType);
                  item.problemType = item.problemType.split("/");
                }
              });
            }
            this.repairRegistrationVo.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });

            });
          });
      },
      getProcess2(row) {
        if (row.shapeCode) {
          let params = {
            sn: row.shapeCode,
          };
          this.$http.get("basic", "snSerialNos/getDBVoBySn", params).then((res) => {
            console.log(res.data);
            row.materialNo = res.data.materialNo;
            row.specifications = res.data.specification;
            row.materialName = res.data.materialDescription;
          }).catch(() => {
            this.$message.error("未查询到条码对应的物料");
          });
        }

      },

      getDetails(row, index) {
        console.log(row);
        // this.repairRegistrationVo.details[index].materialId = row.id;
        this.repairRegistrationVo.details[index].productName = row.name;
        this.repairRegistrationVo.details[index].productModel = row.no;
      },
      addDetails() {
        this.repairRegistrationVo.details.push({
          pkid: 0,
          masterId: 0,
          materialNo: "",
          materialName: "",
          shapeCode: "",
          faultDesc: "",
          specifications: "",
          afterSpecifications: "",
          problemType: "",
          positionNo: "",
          snowboardSupplier: "",
          maintenanceRecord: "",
        });
      },
      oneDelete(index) {
        this.repairRegistrationVo.details.splice(index, 1);
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.repairRegistrationVo.attachments.push(params);
        }
      },
      selectCustomer(row) {
        console.log(row);
        this.repairRegistrationVo.customerName = row.customerName;
        this.repairRegistrationVo.customerId = row.customerID;
      },
      selectMaterial(row) {
        this.repairRegistrationVo.materialId = row.id;
        this.repairRegistrationVo.materialNo = row.no;
        this.repairRegistrationVo.materialName = row.name;
        this.repairRegistrationVo.specification = row.zmyxh;
        console.log(this.repairRegistrationVo);
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (this.repairRegistrationVo.reasonAnalise) {
            this.repairRegistrationVo.reasonAnalise = this.repairRegistrationVo.reasonAnalise.join("/");
          }
          if (this.repairRegistrationVo.details.length>0) {
            this.repairRegistrationVo.details.forEach((item) => {
              if (item.problemType) {
                console.log(item.problemType);
                item.problemType = item.problemType.join("/");
              }
            });
          }
          if (valid) {
            this.submitLoading = true;
            if (this.repairRegistrationVo.pkid > 0) {
              this.$http
                .put("basic", "repairRegistrations/updateBySC", this.repairRegistrationVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "repairRegistrations", this.repairRegistrationVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
      selectRegionalManager(row) {
        this.repairRegistrationVo.repairId = row.systemUserID;
        this.repairRegistrationVo.repairName = row.employeeName;
      },
    },
  };
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  top: 15% !important;
  left: 0 !important;
}
</style>